// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Modal/Modal.css */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--scrim);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal-content {
    background: var(--color-surface);
    width: 640px;
    max-width: 90vw;
    max-height: 90vh;
    border-radius: var(--radius-lg);
    border: 1px solid var(--color-border-subtle);
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 24px 0 24px;
  }

  .modal-title {
    margin: 0;
    flex: 1;
  }

  .modal-close-button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s ease;
  }

  .modal-close-button:hover {
    background-color: var(--color-light-gray);
  }

  .modal-body {
    padding: 24px;
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  .modal-footer {
    padding: 0 24px 24px 24px;
    border-top: 1px solid var(--color-light-gray);
  }

  .modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 16px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Dialog/ModalDialog.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,gCAAgC;IAChC,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,4CAA4C;IAC5C,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,SAAS;IACT,OAAO;EACT;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sCAAsC;EACxC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,aAAa;IACb,OAAO;IACP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,6CAA6C;EAC/C;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;EAClB","sourcesContent":["/* src/components/Modal/Modal.css */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: var(--scrim);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n  }\n  \n  .modal-content {\n    background: var(--color-surface);\n    width: 640px;\n    max-width: 90vw;\n    max-height: 90vh;\n    border-radius: var(--radius-lg);\n    border: 1px solid var(--color-border-subtle);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n  }\n\n  .modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 24px 24px 0 24px;\n  }\n\n  .modal-title {\n    margin: 0;\n    flex: 1;\n  }\n\n  .modal-close-button {\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 8px;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.2s ease;\n  }\n\n  .modal-close-button:hover {\n    background-color: var(--color-light-gray);\n  }\n\n  .modal-body {\n    padding: 24px;\n    flex: 1;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n  }\n\n  .modal-footer {\n    padding: 0 24px 24px 24px;\n    border-top: 1px solid var(--color-light-gray);\n  }\n\n  .modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    margin-top: 16px;\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
